import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import Image from 'swag-client-common/components/ui/image';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { Price } from 'swag-client-common/utils/price';
import css from '../recently-viewed-widget.scss';
const RecentlyViewedItem = ({
  logo,
  name,
  minPrice,
  maxPrice,
  seoSlug,
  minQuant,
  isLE
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    to: `${APP_ROUTES.PRODUCT}/${seoSlug}`
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(css.container, {
      [css.limitedEditionContainer]: isLE
    })
  }, /*#__PURE__*/React.createElement(Image, {
    isLE: isLE,
    LEClassName: css.LEClassName,
    className: css.img,
    wrapperClassName: css.imgWrapperClassName,
    src: logo,
    alt: `${name} product image`
  }), /*#__PURE__*/React.createElement("div", {
    className: css.caption
  }, /*#__PURE__*/React.createElement("div", {
    className: css.name
  }, name), /*#__PURE__*/React.createElement("div", {
    className: css.greyText
  }, "From\xA0", /*#__PURE__*/React.createElement("span", {
    className: css.dark
  }, Price.formatPrice(minPrice)), "\xA0to\xA0", /*#__PURE__*/React.createElement("span", {
    className: css.dark
  }, Price.formatPrice(maxPrice))), /*#__PURE__*/React.createElement("span", {
    className: css.greyText
  }, "Min Qty: ", /*#__PURE__*/React.createElement("span", {
    className: css.dark
  }, minQuant)))));
};
export default RecentlyViewedItem;